import React, { useState } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Box, Tab, Tabs } from '@material-ui/core'

import { TextBox } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import schema from './schema'
import * as service from 'service'
import constants from 'constants/index'

const MessageForm = ({
  complaint,
  complaintId,
  refresh,
  setLoading,
  twoFactorAuthToken,
}) => {
  const snackbar = useSnackbar()

  const { EXTERNAL_VISIBILITY, VISIBILITY_TABS } = constants.complaint
  const [visibility, setVisibility] = useState(EXTERNAL_VISIBILITY)

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      content: '',
      attachments: [],
      complaintStatus: complaint?.status || '',
    },
  })

  const { handleSubmit, reset } = formMethods

  const buttonItems = helpers.complaint.statusButtonItems(complaint?.status)

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.complaintMessage.create({
        complaintId,
        twoFactorAuthToken,
        visibility,
        ...data,
      })
      refresh()
      reset()
      setVisibility(EXTERNAL_VISIBILITY)
      snackbar.open({
        message: 'Mensagem enviada com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      console.error(error)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro tentar enviar a mensagem!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormContext {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} id="complaint-form">
        <TextBox
          buttonItems={buttonItems}
          controlName="complaintStatus"
          form="complaint-form"
        >
          <Box px={2} pt={1}>
            <Tabs
              value={visibility}
              onChange={(event, newValue) => setVisibility(newValue)}
              indicatorColor="primary"
              textColor="primary"
            >
              {VISIBILITY_TABS.map((tab) => (
                <Tab key={tab.id} value={tab.id} label={tab.name} />
              ))}
            </Tabs>
          </Box>
        </TextBox>
      </form>
    </FormContext>
  )
}

MessageForm.propTypes = {
  complaint: PropTypes.object,
  complaintId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  refresh: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  twoFactorAuthToken: PropTypes.string,
}

export default MessageForm
